












































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { InputInterface } from '../types/Exa_Input'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { VueTelInput } from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'


@Component({
    components: {
        VueTelInput,
        FontAwesomeIcon
    }
})
export default class InputPhone extends Vue {
    @Prop() propPhoneNumber?: string;
    @Prop() propRequired?: boolean;
    @Prop() propInputReadOnly?: boolean;
    @Prop() propInputDisabled?: boolean;
    @Prop() propDropdownDisabled?: boolean;
    @Prop() propDefaultCountry?: string;
    @Prop() propPreferredCountries?: string;

    // --- standard------------------------------------------------------------------------------------

    @Prop() private libelle!: string
    @Prop() private description!: string
    @Prop() private value!: any
    @Prop() private ident!: any
    @Prop() private requis!: boolean
    @Prop() private disabled!: boolean
    @Prop() mode_lecture!: boolean
    @Prop() condition!: InputInterface
    @Prop({ default: false }) check_validation!: boolean


    inputHandler() {
        this.$emit('input', { ident: this.ident, value: this.inputPhoneNumber })
    }

    // ------------------------------------------------------------------------------------------------


    inputPhoneNumber = ''

    inputValidity = ''

    infosPhoneInput = {
        phoneNumber: '',
        formattedPhoneNumber: '',
        isValidatedPhoneNumber: false
    }

    isInvalid = ''
    inputBaseClass = ''

    vueTelInputProps = {
        validCharactersOnly: true,
        inputOptions: {
            id: 'phone_input_' + this.ident + '_' + Math.random(),
            placeholder: '',
            required: this.$props.propRequired !== null ? this.$props.propRequired : true,
            readonly: true,
            type: 'tel',
            styleClasses: 'phone_input form-control vuetelinput_class'
        },
        // onlyCountries: ['FR', 'GF', 'PF'],
        defaultCountry: this.$props.propDefaultCountry ? this.$props.propDefaultCountry : 'FR',
        preferredCountries: this.$props.propPreferredCountries ? this.$props.propPreferredCountries : ['FR', 'NC', 'GF', 'MQ', 'PF', 'GP', 'RE', 'MA', 'MR', 'CM', 'CI', 'LB', 'TN', 'GA', 'BF'],
        dropdownOptions: {
            showDialCodeInList: false,
            showDialCodeInSelection: true,
            showFlags: true,
            disabled: true
        }
    }

    openArrowicon = false

    /** 
     * majVueTelInputPhoneNumber 
     * Met à jour la vue du composant VueTelInputPhoneNumber en appelant les fonctions initVueTelInputReadOnly() et majVueTelInputModel(). 
     * @param {None} - Aucun paramètre requis. 
     */
    @Watch('value')
    majVueTelInputPhoneNumber () {
        this.initVueTelInputReadOnly()
        this.majVueTelInputModel()
    }

    /** 
     * majVueTelInputReadOnly 
     * Met à jour la vue du composant VueTelInputReadOnly en appelant les fonctions initVueTelInputReadOnly() et majVueTelInputModel(). 
     * @param {None} - Aucun paramètre requis. 
     */
    @Watch('propInputReadOnly')
    majVueTelInputReadOnly () {
        this.initVueTelInputReadOnly()
        this.majVueTelInputModel()
    }

    /** 
     * beforeMount 
     * Effectue des opérations avant le montage du composant, notamment l'initialisation de VueTelInputReadOnly et l'affectation de la valeur à inputPhoneNumber. 
     * @param {None} - Aucun paramètre requis. 
     */
    beforeMount () {
        this.initVueTelInputReadOnly()
        this.inputPhoneNumber = this.value
    }

    /** 
     * majVueTelInputModel 
     * Met à jour la valeur de inputPhoneNumber avec la valeur actuelle. 
     * @param {None} - Aucun paramètre requis. 
     */
    majVueTelInputModel () {
        this.inputPhoneNumber = this.value
    }

    /** 
     * initVueTelInputReadOnly 
     * Initialise les options de lecture seule pour le composant VueTelInput en fonction des propriétés fournies. 
     * @param {None} - Aucun paramètre requis. 
     */
    initVueTelInputReadOnly () {
        this.vueTelInputProps.inputOptions.readonly = this.$props.propInputReadOnly
        this.vueTelInputProps.inputOptions.styleClasses = this.$props.propInputReadOnly ? 'form-control-plaintext form-control vuetelinput_class' : 'form-control vuetelinput_class'
        this.inputBaseClass = this.vueTelInputProps.inputOptions.styleClasses
        this.vueTelInputProps.dropdownOptions.disabled = this.$props.propDropdownDisabled
    }

    /** Ne sert pas à priori finalement (pour l'instant) */
    /** 
     * initVueTelInputValidClass 
     * Initialise les classes de style pour le composant VueTelInput en fonction de la validité spécifiée. 
     * @param {boolean} valid - Indique si l'input est valide ou non. 
     */
    initVueTelInputValidClass (valid: boolean) {
        this.vueTelInputProps.inputOptions.styleClasses = (valid === true ? this.inputBaseClass : this.inputBaseClass + ' is-invalid')
    }

    /** 
     * onDropdownOpen 
     * Met à jour la valeur de la propriété openArrowicon en fonction de la valeur spécifiée. 
     * @param {boolean} valeur - La valeur indiquant si le dropdown est ouvert ou non. 
     */   
    onDropdownOpen (valeur: boolean) {
        this.openArrowicon = valeur
    }

    /** 
     * onDropdownClose 
     * Met à jour la valeur de la propriété openArrowicon en fonction de la valeur spécifiée. 
     * @param {boolean} valeur - La valeur indiquant si le dropdown est fermé ou non. 
     */
    onDropdownClose (valeur: boolean) {
        this.openArrowicon = valeur
    }

    /** 
     * vueTelInputEvent 
     * Gère les événements de saisie de l'input de numéro de téléphone. 
     * @param {string} number - Le numéro de téléphone saisi. 
     * @param {any} phoneObject - L'objet représentant le numéro de téléphone. 
     */
    vueTelInputEvent (number: string, phoneObject: any) {
        this.infosPhoneInput.formattedPhoneNumber = phoneObject.number
        this.infosPhoneInput.phoneNumber = this.inputPhoneNumber

        if (phoneObject.valid) {
            this.isInvalid = ''
            this.infosPhoneInput.isValidatedPhoneNumber = true
        } else {
            this.isInvalid = (this.inputPhoneNumber === '' && phoneObject.number === undefined && this.vueTelInputProps.inputOptions.required === false) ? 'vuetelinput_invalid_empty' : 'vuetelinput_invalid'
            this.infosPhoneInput.isValidatedPhoneNumber = false
        }
        this.inputHandler()
    }

    /** 
     * vueTelValidateEvent 
     * Valide le numéro de téléphone saisi et met à jour les propriétés correspondantes. 
     * @param {any} phoneObject - L'objet représentant le numéro de téléphone. 
     */
    vueTelValidateEvent (phoneObject: any) {
        this.inputValidity = ''
        this.infosPhoneInput.phoneNumber = this.inputPhoneNumber
        if (phoneObject.valid) {
            this.isInvalid = ''
            this.inputValidity = ''
            this.infosPhoneInput.isValidatedPhoneNumber = true
            this.$emit('anomalieHandler', { ident: this.ident, anomalie: this.inputValidity })
        } else {
            this.isInvalid = (this.inputPhoneNumber === '' && phoneObject.number === undefined && this.vueTelInputProps.inputOptions.required === false) ? 'vuetelinput_invalid_empty' : 'vuetelinput_invalid'
            this.infosPhoneInput.isValidatedPhoneNumber = false
            this.inputValidity = 'Le format du numéro de téléphone est incorrect.'
            this.$emit('anomalieHandler', { ident: this.ident, anomalie: this.inputValidity })
        }
    }

    /** 
     * vueTelCountryChangeEvent 
     * Gère le changement de pays dans le composant vue-tel-input et met à jour les propriétés correspondantes. 
     * @param {any} countryObject - L'objet représentant le pays sélectionné. 
     */
    vueTelCountryChangeEvent (countryObject: any) {
        this.infosPhoneInput.formattedPhoneNumber = countryObject.number
        this.infosPhoneInput.phoneNumber = this.inputPhoneNumber

        if (countryObject.valid) {
            this.isInvalid = ''
            this.infosPhoneInput.isValidatedPhoneNumber = true
        } else {
            this.isInvalid = (this.inputPhoneNumber === '' && countryObject.number === undefined && this.vueTelInputProps.inputOptions.required === false) ? 'vuetelinput_invalid_empty' : 'vuetelinput_invalid'
            this.infosPhoneInput.isValidatedPhoneNumber = false
        }
    }
}
